module.exports = __webpack_public_path__ + "img/botaosetelagoassetcemg.b428b625.png";